class MainSearch extends SearchForm {
  constructor() {
    super();

    this.allSearchInputs = document.querySelectorAll(
      'input[type="search"][name="q"]'
    );

    this.setupEventListeners();
  }

  setupEventListeners() {
    const allSearchForms = new Set();

    this.allSearchInputs.forEach((input) => {
      if (input.form) {
        allSearchForms.add(input.form);
      }
    });

    this.input.addEventListener(
      'focus',
      this.onInputFocus.bind(this)
    );

    allSearchForms.forEach((form) => {
      form.addEventListener(
        'reset',
        this.onFormReset.bind(this)
      );

      form.addEventListener(
        'submit',
        this.onFormSubmit.bind(this)
      );
    });

    this.allSearchInputs.forEach((input) => {
      input.addEventListener(
        'input',
        this.onInput.bind(this)
      );
    });
  }

  cleanSearchTerm(value) {
    return value
      .trim()
      .replace(/^["'‘’“”]+|["'‘’“”]+$/g, '')
      .trim();
  }

  onFormSubmit(event) {
    const form = event.currentTarget;
    const searchInput = form.querySelector(
      'input[type="search"][name="q"]'
    );

    if (!searchInput) return;

    const cleanTerm = this.cleanSearchTerm(
      searchInput.value
    );

    if (!cleanTerm) {
      event.preventDefault();
      searchInput.focus();
      return;
    }

    event.preventDefault();

    const searchUrl =
      `${window.Shopify.routes.root}search` +
      `?q=${encodeURIComponent(cleanTerm)}` +
      `&type=product`;

    window.location.assign(searchUrl);
  }

  onFormReset(event) {
    super.onFormReset(event);

    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    const cleanValue = this.cleanSearchTerm(
      target.value
    );

    this.keepInSync(cleanValue, target);
  }

  onInputFocus() {
    if (window.innerWidth < 750) {
      this.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

if (!customElements.get('main-search')) {
  customElements.define('main-search', MainSearch);
}